import script from "./tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./tag.vue?vue&type=script&setup=true&lang=ts"

import "./tag.vue?vue&type=style&index=0&id=bdb75952&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdb75952"]])

export default __exports__